/**
 * Quiet landing page until the curation tools land. Bindery is desktop-
 * primary, keyboard-driven (PROJECT.md §The apps) — batch upload,
 * metadata entry, tagging, moderation. Building it is a separate
 * project that comes after living with Almanac.
 *
 * No API call from this page on purpose — there's nothing to fetch yet,
 * and the previous health-check stub generated misleading errors once
 * the API moved behind Cloudflare Access.
 */
export function HomePage() {
  return (
    <section>
      <div
        style={{
          fontSize: 'var(--font-size-caption)',
          fontWeight: 'var(--font-weight-medium)',
          letterSpacing: 'var(--letter-spacing-wide)',
          textTransform: 'uppercase',
          color: 'var(--text-tertiary)',
          marginBottom: '1.5rem',
        }}
      >
        Curation workshop
      </div>
      <h2
        style={{
          fontSize: 'clamp(1.5rem, 3vw, 2rem)',
          fontWeight: 500,
          letterSpacing: '-0.02em',
          marginBottom: '0.75rem',
        }}
      >
        Not yet bound.
      </h2>
      <p
        style={{
          color: 'var(--text-secondary)',
          maxWidth: '56ch',
          marginBottom: '2rem',
        }}
      >
        Bindery is the desktop tool for batch upload, metadata entry, and
        tagging — the workshop where folios are bound before the family
        archive sees them. Nothing to do here yet; the curation surfaces
        will land once Almanac has been lived in for a few weeks.
      </p>
    </section>
  );
}
